import React from 'react';

const Intro = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    },
    content: {
      textAlign: 'center',
    },
    name: {
      fontSize: '4rem',
      fontWeight: 'bold',
      letterSpacing: '0.1em',
      textTransform: 'uppercase'
    },
    title: {
      fontSize: '2rem',
      fontWeight: 'bold',
      textAlign: 'center',
      letterSpacing: '0.1em'
    },
    chevronContainer: {
      position: 'absolute',
      bottom: '3rem',
      animation: 'bounce 2s infinite'
    },
    chevron: {
      width: '60px',
      height: '60px',
      cursor: 'pointer'
    }
  };

  // Add keyframe animation
  const styleSheet = document.styleSheets[0];
  const keyframes = `
    @keyframes bounce {
      0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
      }
      40% {
        transform: translateY(-10px);
      }
      60% {
        transform: translateY(-5px);
      }
    }
  `;
  
  React.useEffect(() => {
    // Check if animation already exists
    let animationExists = false;
    for (let i = 0; i < styleSheet.cssRules.length; i++) {
      if (styleSheet.cssRules[i].name === 'bounce') {
        animationExists = true;
        break;
      }
    }
    if (!animationExists) {
      styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
    }
  }, []);

  const scrollToNext = () => {
    window.scrollBy({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div style={styles.container} id="intro">
      <div style={styles.content}>
        <h1 style={styles.name}>MICHAEL MOROSA</h1>
        <p style={styles.title}>Software Engineer</p>
      </div>
      
      <div style={styles.chevronContainer} onClick={scrollToNext}>
        <svg 
          style={styles.chevron}
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
    </div>
  );
};

export default Intro;